<script context="module" lang="ts">
	import icoEdit from 'iconoir/icons/edit-pencil.svg';
	import icoRight from 'iconoir/icons/arrow-right-circle.svg';

	import Tag from '../utils/tag.svelte';

	import getPermissions from '../auth/getPermissions';

	async function canEdit() {
		return await getPermissions('edit-program');
	}
</script>

<script lang="ts">
	export let id = null;
	export let title = 'Undefined';
	export let body = 'Undefined';
	export let image = '';
	export let imageFocal = 'center center';
	export let length = 'Unknown Length';
	export let ages = 'Unknown Ages';
</script>

<div
	class="relative rounded-md bg-white p-2 drop-shadow-sm md:border-[1px] md:border-zinc-100 md:drop-shadow-md"
>
	<a href="/programs/{id}">
		<div
			style="background: url({image}); background-repeat: no-repeat; background-size: cover; background-position: {imageFocal};"
			class="relative h-40 rounded md:h-52"
		>
			<Tag content={length} class="absolute top-0 m-2" />
			<Tag content={ages} accent="true" class="absolute bottom-0 m-2" />
		</div>
		<div class="mb-8 mt-2">
			<h2 class="text-lg text-neutral-900 dark:text-neutral-100">{title}</h2>
			<p class="text-neutral-800 dark:text-neutral-200">{body}</p>
			<p class="absolute bottom-2 text-sm font-light text-zinc-700 dark:text-zinc-200">
				Learn More &rightarrow;
			</p>
		</div>
	</a>
	{#await canEdit()}
		<div />
	{:then result}
		{#if result == true}
			<div class="absolute bottom-2 right-2">
				<a href="/programs/edit/{id}" class="flex items-center">
					<img
						src={icoEdit}
						alt="Edit Icon"
						class="inline-block h-4"
						style="filter: invert(21%) sepia(19%) saturate(259%) hue-rotate(202deg) brightness(95%) contrast(86%);"
					/>
					<p class="ml-2 inline-block align-middle text-sm text-zinc-700">Edit</p>
				</a>
			</div>
		{/if}
	{/await}
</div>
